export default __webpack_public_path__ + "static/media/Anisha.bcbc72e5.png";